// src/components/projects/VentingRoom.js
import React from "react";
import "../../styles/ventingRoom.css";
import Multimedia from "../../assets/multimedia.jpg";
import UserReport from "../../assets/UserReport.jpg";
import TrendingNews from "../../assets/TrendingNews.jpg";
import Privacy from "../../assets/Privacy.jpg";
import Settings from "../../assets/Settings.jpg";
import SocialInjustice from "../../assets/social-injustice.jpg";
import EconomicHell from "../../assets/economic-hell.jpg";
import FamilyFire from "../../assets/family-fire.jpg";
import RomanticChaos from "../../assets/romantic-chaos.jpg";
import EcosystemPlus from "../../assets/ecosystem-plus.jpg";
import Emergency from "../../assets/emergency.jpg";


const ventingRoomData = {
  introduction: "Venting Room is a digital platform that allows users to express their emotions anonymously or semi-anonymously through categorised spaces. Whether it's discussing social injustice, economic struggles, or personal challenges, users have a safe place to share their thoughts.",
  categories: [
    { title: "Social Injustice", description: "Share experiences and frustrations related to inequality and systemic issues.", image: SocialInjustice },
    { title: "Economic Hell", description: "Discuss financial difficulties, unemployment, and economic struggles.", image: EconomicHell },
    { title: "Family Fire", description: "Express thoughts on family conflicts, parenting challenges, and relationships.", image: FamilyFire },
    { title: "Romantic Chaos", description: "Talk about love, heartbreak, and relationship issues in a judgment-free space.", image: RomanticChaos },
    { title: "Ecosystem +", description: "Raise concerns and insights on environmental and societal impact.", image: EcosystemPlus },
    { title: "Emergency", description: "Immediate emotional support for crisis situations.", image: Emergency }
  ],
  features: [
    { title: "Multimodal Sharing", description: "Express yourself via video, audio, images, or documents.", image: Multimedia },
    { title: "Usage Report", description: "Track your engagement and see how much value you're deriving from the service.", image: UserReport },
    { title: "Trending News", description: "Stay updated with the most discussed topics in the community.", image: TrendingNews },
    { title: "Privacy Focused", description: "Clear privacy policies ensuring data protection and anonymity.", image: Privacy },
    { title: "Customisable Settings", description: "Personalise your experience with adjustable settings.", image: Settings }
  ]
};

const VentingRoom = () => {
  return (
    <div className="venting-room">
      <h1>Venting Room</h1>

      {/* Introduction Section */}
      <section className="intro">
        <p>{ventingRoomData.introduction}</p>
      </section>

      {/* Categories Section */}
      <section className="categories">
        <h2>Categorised "Rooms"</h2>
        <div className="categories-grid">
          {ventingRoomData.categories.map((category, index) => (
            <div key={index} className="category-card">
              <img src={category.image} alt={category.title} className="category-image" />
              <h3>{category.title}</h3>
              <p>{category.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <h2>Platform Features</h2>
        <div className="features-grid">
          {ventingRoomData.features.map((feature, index) => (
            <div key={index} className="feature-card">
              <img src={feature.image} alt={feature.title} className="feature-image" />
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default VentingRoom;